"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    customRubrics: {
        category: {
            name: {
                withoutCategories: 'default',
            },
            proficiencyTitle: '{{label}} | {{score}} pts',
        },
        sampleAnswer: {
            title: 'Sample Answer',
            expandButton: 'Expand',
            questionTitle: 'Question {{questionNumber}}',
        },
    },
};
